import { updateData } from "./updateData";

export const submitNewUrl = async (newURL, SetIsError, SetErrorMessage) => {
  let validatedURL;

  try {
    // Try parsing as-is
    validatedURL = new URL(newURL);
  } catch {
    try {
      // Try with https://
      validatedURL = new URL("https://" + newURL);
    } catch {
      SetIsError(true);
      SetErrorMessage("Please enter a valid URL (e.g., https://example.com)");
      return false;
    }
  }

  const hostname = validatedURL.hostname.replace("www.", "");

  // 🚫 Check if hostname is likely invalid (e.g., dfsfsdfsdffds)
  if (!hostname.includes('.') || hostname.endsWith('.')) {
    SetIsError(true);
    SetErrorMessage("Please enter a valid domain (e.g., example.com)");
    return false;
  }

  console.log("Valid domain:", hostname);

  // Continue with logic
  const serverResponse = await updateData(hostname, SetIsError, SetErrorMessage);
  return serverResponse;

  return true;
};